import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  action?: React.ReactNode;
  icon?: React.ReactNode;
}
export function Card({
  children,
  className = '',
  title,
  action,
  icon
}: CardProps) {
  return <div className={`bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col ${className}`} data-id="element-1232">
      {(title || action) && <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between bg-gradient-to-r from-gray-50 to-orange-50/30" data-id="element-1233">
          <div className="flex items-center gap-2" data-id="element-1234">
            {icon && <span className="text-orange-500" data-id="element-1235">{icon}</span>}
            {title && <h3 className="text-base font-semibold text-gray-900" data-id="element-1236">{title}</h3>}
          </div>
          {action && <div data-id="element-1237">{action}</div>}
        </div>}
      <div className="p-3 flex-1" data-id="element-1238">{children}</div>
    </div>;
}